import version from './version';
import config from '../../config';

const blobUrls = {};

export async function blobURLFromSrc(src) {
	if (!blobUrls[src]) {
		// WebPack HMR repeatedly tries to establish a WS connection to 0:0:0:0 when
		// we use blob URL's locally. This obviously fails, which results in the log
		// being flooded with errors. So, when local, we'll use the URL directly.
		// When hosted, we'll use blob URL's to benefit from local caching.
		const versionedSrc = `${src}?v=${version}`;
		if (config.isLocal) {
			blobUrls[src] = Promise.resolve(versionedSrc)
		} else {
			blobUrls[src] = fetch(versionedSrc)
				.then(r => r.blob())
				.then(blob => URL.createObjectURL(blob))
			;
		}
	}
	return blobUrls[src];
}